import * as React from 'react';

interface NewJobNotes {

}

interface NewJobNoteProps {
    currentStep: number;
    saveDisabled: boolean;
    notes: string;
    goPrev(): void;
    update(notes: string): void;
    goNext(): void;
}

export default class NewJobNote extends React.Component<NewJobNoteProps, NewJobNotes> {
    constructor(props: NewJobNoteProps) {
        super(props);

    }

    handleChange = (e: any) => {
        this.props.update(e.target.value);
    }

    prev = () => {
        this.props.goPrev();
    }

    finish = () => {
        this.props.goNext();
    }

    render() {

        if (this.props.currentStep !== 5) {
            return null;
        }
        return (
            <div>
                <p> Enter any notes from the conversation with the customer </p>
                <div>
                    <label className="input-group" htmlFor="notes">
                        <textarea className="notes__finalSize" id="notes" name="notes" value={this.props.notes} onChange={(e) => this.handleChange(e)}></textarea>
                    </label>
                </div>
                <div className="input-group-parent">
                    <button className="defaultbutton" onClick={this.prev} type="button">Prev</button>
                </div>
                <div className="input-group-parent">
                    <div className="colAlignRight">
                        <button className="defaultbutton--save" onClick={this.finish} type="button" disabled={this.props.saveDisabled}>Finish</button>
                    </div>
                    <div className="makeitflexright marginRight10">{this.props.saveDisabled ? "Saving..." : ""}</div>
                </div>

            </div>
        );
    }
}